import dayjs from "dayjs";
import * as yup from "yup";
import {
  dateRangeRequiredMessage,
  fleetGarageCommaListMessage,
  fleetGarageCommaListRegexOrEmptyString,
  lessOrEqualOneYearMessage,
  requiredMessage,
  rateClassCommaListRegexOrEmptyString,
  rateClassCommaListMessage
} from "../../components/shared/form/formValidatonRules";

const formatMultiLineYupMessage = (message) => message.replace(/\n/g, "<br />");

export const productionReportSchema = yup.object().shape({
  AgencyKeys: yup.array().required(requiredMessage).min(1, requiredMessage),
  TransactionDate: yup
    .array()
    .test(
      "lessThanYear",
      lessOrEqualOneYearMessage,
      (value) => dayjs(value[1]).diff(dayjs(value[0]), "year") === 0
    )
    .required(dateRangeRequiredMessage)
    .nullable(),
  SortGroupFields: yup.array().of(
    yup.object().shape({
      Name: yup.string().required(requiredMessage),
    })
  ),
  DrillDownSortFields: yup.array().of(
    yup.object().shape({
      Name: yup.string().required(requiredMessage),
    })
  ),
  Include: yup
    .boolean()
    .when(
      [
        "IncludeCancellations",
        "IncludeNonFleetNonGarage",
        "IncludeFleetGarage",
      ],
      {
        is: false,
        then: yup
          .boolean()
          .required("At least one of the options is required."),
      }
    ),
  FleetGaragePolicyNumbers: yup
    .string()
    .matches(
      fleetGarageCommaListRegexOrEmptyString,
      fleetGarageCommaListMessage
    ),

  RateClass: yup
    .string()
    .matches(
      rateClassCommaListRegexOrEmptyString,
      formatMultiLineYupMessage(rateClassCommaListMessage)
    ),

  IncludeLeased: yup.boolean(),
  IncludeNotLeased: yup.boolean(),
  LeasedVehicle: yup
    .boolean()
    .test(
      "atLeastOneSelected",
      "At least one option must be selected (Yes or No)",
      function () {
        return this.parent.IncludeLeased || this.parent.IncludeNotLeased;
      }
    ),
});
